import { Box, type BoxProps } from "@mui/material"
import { styled } from "@mui/material/styles"

interface IconWrapperProps extends BoxProps {
    active: boolean
    collapsed: boolean
}

const IconWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== "active" && prop !== "collapsed",
})<IconWrapperProps>(({ theme, active, collapsed }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: collapsed ? 0 : "16px",
    color: active ? "#424242" : "#757575",
    "& .MuiSvgIcon-root": {
        fontSize: 24,
    },
}))

export default IconWrapper

